// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthLayout_wrapper__BDEx7","container":"AuthLayout_container__RAMvG","content":"AuthLayout_content__1Ff4F"};